"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stableStringify = void 0;
const safe_stable_stringify_1 = require("safe-stable-stringify");
exports.stableStringify = safe_stable_stringify_1.stringify;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhYmxlLXN0cmluZ2lmeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9zdGFibGUtc3RyaW5naWZ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlFQUFpRDtBQUVwQyxRQUFBLGVBQWUsR0FBRyxpQ0FBUyxDQUFBIn0=